import React, { useState } from 'react';
import TabPanel, { a11yProps } from '../../../common/Tabs/TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CST from './CST';
import RT from './RT';
import SRT from './SRT';
import Discharge from './Discharge';

const Oras = () => {
  const [value, setValue] = useState(0);
  
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
  	<Box sx={{ width: '100%'}}>
        <Box
          style={{
            backgroundColor: '#fafafb',
            position: 'sticky',
            top: '285px',
            zIndex: 2,
          }}
        >
          <Box 
            sx={{
              borderBottom: 2,
              borderColor: '#747070',
              padding: '15px 0px 5px 0px',
            }}
          >
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label='episode tabs'
            >
              <Tab label='CST' {...a11yProps(0)} />
              <Tab label='RT' {...a11yProps(1)} />
              <Tab label='SRT' {...a11yProps(2)} />
              <Tab label='Discharge' {...a11yProps(3)} />
            </Tabs>
          </Box>
        </Box>
        <TabPanel value={value} index={0}>
          <CST />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <RT />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <SRT />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Discharge />
        </TabPanel>
    </Box>    
  );
};

export default Oras;  	